import type { InvitationStatus, MemberStatus, ScopeType } from '@fc/core'

export const MEMBER_STATUS_LABEL: Record<MemberStatus, string> = {
  active: 'Active',
  invited: 'Invited',
  suspended: 'Suspended',
  locked: 'Locked',
}

export const MEMBER_STATUS_VARIANT: Record<
  MemberStatus,
  'success' | 'neutral' | 'warning' | 'danger'
> = {
  active: 'success',
  invited: 'neutral',
  suspended: 'danger',
  locked: 'warning',
}

export const INVITATION_STATUS_LABEL: Record<InvitationStatus, string> = {
  pending: 'Pending',
  accepted: 'Accepted',
  revoked: 'Revoked',
  expired: 'Expired',
}

export const INVITATION_STATUS_VARIANT: Record<
  InvitationStatus,
  'success' | 'neutral' | 'warning' | 'danger'
> = {
  pending: 'warning',
  accepted: 'success',
  revoked: 'neutral',
  expired: 'danger',
}

export const SCOPE_LABEL: Record<ScopeType, string> = {
  org: 'Organization',
  site: 'Site',
  team: 'Team',
  group: 'Group',
}

/** "Org Admin" or "Group Leader · High School" */
export function describeScope(scopeType: ScopeType, scopeLabel: string | null): string {
  if (scopeType === 'org') return 'Organization-wide'
  return `${SCOPE_LABEL[scopeType]}${scopeLabel ? ` · ${scopeLabel}` : ''}`
}
